<template>
  <div class="page-main">
    <e-tabs v-if="isLoadTab" :list="statusList" :activeVal.sync="bill_status1" />

    <div class="flex w-100">
      <b-filter-left
        ref="refLeftFilter"
        :init_filter_data="init_filter_data"
        :search_data="search_data"
        @success="updateLeftFilter"
      />
      <div class="flex-1 w-0">
        <div class="flex flex-y-center flex-x-between m-b-10">
          <div class="flex flex-y-center">
            <el-dropdown v-if="isShowBatch">
              <el-button type="default" size="mini">
                批量操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="left_filter_data.search_type === '原料'"
                  @click.native="batchPurchaseApply"
                >
                  <span class="c-green">生成采购申请单</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-form class="flex flex-y-center m-l-10" @submit.native.prevent="resetLeftFilter">
              <span>销售日期:</span>
              <e-date-picker
                type="daterange"
                :value.sync="bill_date"
                isShowFast
                @change="resetLeftFilter"
              />
              <el-button
                v-show="false"
                type="danger"
                size="mini"
                class="m-l-10"
                :loading="finishLoading"
                @click="itemFinishBatch"
              >
                批量完成20条
              </el-button>
            </el-form>
          </div>
        </div>
        <!-- 表格 -->
        <vxe-grid
          ref="refTable"
          :show-footer="!!tableData.length"
          :loading="loading"
          :columns="tableColumn"
          :data="tableData"
          :height="this.$util.getViewHeight() - 36 - 184"
          :footer-method="footerMethod"
          :cell-class-name="cellClassName"
          @resizable-change="handleColumnResize"
          @keydown="tableKeydown"
          @current-change="tableCurrentChange"
        >
          <!-- slot_default -->
          <!-- resultStart -->
          <template #default_bill_code="{ row }">
            <el-link type="primary" @click="itemXiaoShou(row.a_id)">
              {{ row.bill_code }}
            </el-link>
            <el-link :type="row.status_str === '已完结' ? 'success' : 'primary'">
              ({{ row.status_str }})
            </el-link>
          </template>
          <template #default_zhi_zao_ming_xi="{ row }">
            <el-link type="primary" @click="itemMadeDetail(row.a_id)">
              <div class="flex flex-y-center">
                <span class="iconfont icon-dingdan f-s-12"></span>
                <span>制造明细</span>
              </div>
            </el-link>
          </template>
          <template #default_zhi_zao_liu_cheng="{ row }">
            <el-link type="primary" @click="itemMadeView(row.a_id)">
              <div class="flex flex-y-center">
                <span class="iconfont icon-ziliucheng f-s-12"></span>
                <span class="m-l-2">制造流程</span>
              </div>
            </el-link>
          </template>
          <template #default_jiao_huo_ri_qi="{ row }">
            <div>{{ row.jiao_huo_ri_qi || '-' }}</div>
            <div class="c-orange">{{ row.jiao_huo_ri_qi_str }}</div>
          </template>
          <template #default_list_chan_pin_tu="{ row }">
            <e-upload-image
              v-if="row.list_chan_pin_tu"
              :list.sync="row.list_chan_pin_tu"
              disabled
            />
          </template>

          <!-- resultOrderNo -->
          <template #default_list_gong_cheng_tu="{ row }">
            <e-upload-image
              v-if="row.list_gong_cheng_tu"
              :list.sync="row.list_gong_cheng_tu"
              disabled
            />
          </template>
          <template #default_list_yuan_wen_jian="{ row }">
            <e-upload-file
              v-if="row.list_yuan_wen_jian"
              :list.sync="row.list_yuan_wen_jian"
              disabled
            />
          </template>
          <template #default_list_jian_ce_mu_ban="{ row }">
            <e-upload-file
              v-if="row.list_jian_ce_mu_ban"
              :list.sync="row.list_jian_ce_mu_ban"
              disabled
            />
          </template>
          <template #default_list_jian_ce_bao_gao="{ row }">
            <e-upload-file
              v-if="row.list_jian_ce_bao_gao"
              :list.sync="row.list_jian_ce_bao_gao"
              disabled
            />
          </template>
          <template #default_jin_du="{ row }">
            <div class="flex flex-center">
              <div
                class="flex flex-y-center"
                v-for="(item, index) in diffSearchTypeShowData.list"
                :key="index"
              >
                <span v-if="index">-</span>
                <el-link v-if="row.jin_du === index" type="primary">{{ item }}</el-link>
                <el-link v-if="row.jin_du > index" type="success">{{ item }}</el-link>
                <el-link v-if="row.jin_du < index" type="danger">{{ item }}</el-link>
              </div>
            </div>
          </template>

          <!-- resultEnd -->
          <template #default_operate="{ row }">
            <el-dropdown>
              <el-button type="default" size="mini">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="itemSetDoing(row.a_id)">
                  设置执行中
                </el-dropdown-item>
                <el-dropdown-item @click.native="itemSetComplete(row.a_id)">
                  设置已完成
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="!isShowJiaGongDo"
                  @click.native="itemMadeDetail(row.a_id)"
                >
                  设置工单
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="isShowJiaGongDo"
                  @click.native="itemRenwu(row.a_id, row.id)"
                >
                  生产工单
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="isShowJiaGongDo"
                  @click.native="itemWeiwai(row.a_id, row.id)"
                  >委外工单
                </el-dropdown-item>
                <el-dropdown-item @click.native="itemDelete(row)">
                  <span class="c-red">删除</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>

          <!-- slot_pager -->
          <template #pager>
            <div></div>
            <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
          </template>
        </vxe-grid>
      </div>
    </div>

    <!-- 弹窗-销售订单 -->
    <PopupXiaoShou
      v-if="isShowPopupXiaoShou"
      :show.sync="isShowPopupXiaoShou"
      :billId="activeBillId"
      @success="updatePage"
    />

    <!-- 弹窗-生产工单增改 -->
    <PopupRenwu
      v-if="isShowPopupRenwu"
      :show.sync="isShowPopupRenwu"
      :billId="activeBillId"
      :jiagongId="activeJiagongId"
      @success="updatePage"
    />

    <!-- 弹窗-委外工单增改 -->
    <PopupWeiwai
      v-if="isShowPopupWeiwai"
      :show.sync="isShowPopupWeiwai"
      :billId="activeBillId"
      :jiagongId="activeJiagongId"
      @success="updatePage"
    />

    <!-- 弹窗-制造明细 -->
    <b-popup-verify-goods-detail
      v-if="isShowPopupVerifyGoodsDetail"
      :show.sync="isShowPopupVerifyGoodsDetail"
      :id="activeBillId"
      :isVerify="false"
    />

    <!-- 弹窗-制造流程 -->
    <b-popup-verify-goods-view
      v-if="isShowPopupVerifyGoodsView"
      :show.sync="isShowPopupVerifyGoodsView"
      :id="activeBillId"
      :isVerify="false"
    />

    <!-- 弹窗-采购申请-批量 -->
    <PopupBatchPurchaseApply
      v-if="isShowPopupBatchPurchaseApply"
      :show.sync="isShowPopupBatchPurchaseApply"
      :list="activeBatchList"
      @success="searchListData"
    />
  </div>
</template>

<script>
export default {
  tableName: 'new_pmc_page_list',
  components: {
    PopupXiaoShou: () => import('../common/popup-do/index'),
    PopupRenwu: () => import('@/views/new/renwu/common/popup-do/index'),
    PopupWeiwai: () => import('@/views/new/weiwai/common/popup-do/index'),
    PopupBatchPurchaseApply: () => import('../../purchase/apply/common/popup-do')
  },
  data() {
    return {
      // loading
      loading: true,
      isLoadTab: false,

      // filter
      bill_date: [this.$util.getDate().monthStart, this.$util.getDate().monthEnd],
      sortData: {
        a_id: 'desc'
      },
      bill_status1: '全部',
      init_filter_data: {
        active_parent_key: '全部订单',
        active_search_type: '单据',
        hide_count_keys: [],
        api_url_parent: '/admin/gcvip/pmc/leftFatherFilter3',
        api_url_child: '/admin/gcvip/pmc/leftFilter3'
      },
      left_filter_data: {
        search_type: '单据',
        list: []
      },

      // table
      tableData: [],
      pageOptions: {
        ...this.$constant.page
      },
      totalObj: {
        dai_zhi_xing_count: '',
        zhi_xing_zhong_count: '',
        yi_wan_cheng_count: ''
      },

      // popup
      isShowPopupXiaoShou: false,
      isShowPopupRenwu: false,
      isShowPopupWeiwai: false,
      isShowPopupVerifyGoodsDetail: false,
      isShowPopupVerifyGoodsView: false,
      activeBillId: null,
      activeJiagongId: null,

      isShowPopupBatchPurchaseApply: false,
      activeBatchList: [],

      // 批量完成
      finishLoading: false
    }
  },
  computed: {
    // 搜索参数
    search_data() {
      let result = {
        bill_status1: this.bill_status1 === '全部' ? 'PMC订单' : this.bill_status1,
        bill_date: this.bill_date || []
      }
      return result
    },
    // 是否是管理员
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    },
    // 是否显示批量操作
    isShowBatch() {
      let result = this.left_filter_data.search_type === '原料'
      return result
    },
    // 是否显示加工操作
    isShowJiaGongDo() {
      let result = this.left_filter_data.search_type === '加工'
      return result
    },
    // 当前登录账号id
    accountId() {
      return this.$store.state.loginAccount.id
    },
    // 状态列表
    statusList() {
      let result = [
        {
          key: '全部',
          val: '全部',
          type: 'info'
        },
        {
          key: '待执行',
          val: '待执行',
          count: this.totalObj.dai_zhi_xing_count,
          type: 'primary',
          isRed: true
        },
        {
          key: '执行中',
          val: '执行中',
          count: this.totalObj.zhi_xing_zhong_count,
          type: 'warning'
        },
        {
          key: '已完成',
          val: '已完成',
          count: this.totalObj.yi_wan_cheng_count,
          type: 'success'
        }
      ]
      return result
    },
    // 左侧筛选最后是否选中商品
    isLeftLastChooseGoods() {
      let { search_type, list } = this.left_filter_data
      let len = list.length
      let result = search_type === '单据' && len && list[len - 1].field === 'name' // 确保选中的是单据的商品
      return !!result
    },
    // 不同搜索类型的显示的数据
    diffSearchTypeShowData() {
      let result = {}
      if (this.left_filter_data.search_type === '单据' && this.isLeftLastChooseGoods) {
        result = {
          type: '商品',
          list: []
        }
      }
      if (this.left_filter_data.search_type === '单据' && !this.isLeftLastChooseGoods) {
        result = {
          type: '商品',
          list: ['待执行', '执行中', '已完成']
        }
      }
      if (this.left_filter_data.search_type === '原料') {
        result = {
          type: '原料',
          list: ['待采购', '采购中', '已入库']
        }
      }
      if (this.left_filter_data.search_type === '加工') {
        result = {
          type: '工艺',
          list: ['待加工', '加工中', '已完成']
        }
      }
      if (this.left_filter_data.search_type === '费用') {
        result = {
          type: '费用',
          list: ['待执行', '执行中', '已完成']
        }
      }
      return result
    },
    // 表格列
    tableColumn() {
      let resultStart = [
        {
          fixed: 'left',
          type: 'checkbox',
          width: 40,
          visible: this.isShowBatch
        },
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          fixed: 'left',
          title: '销售单号',
          field: 'bill_code',
          slots: { default: 'default_bill_code' }
        },
        {
          title: '制造明细',
          field: 'zhi_zao_ming_xi',
          slots: { default: 'default_zhi_zao_ming_xi' }
        },
        {
          title: '制造流程',
          field: 'zhi_zao_liu_cheng',
          slots: { default: 'default_zhi_zao_liu_cheng' }
        },
        {
          title: '订单类型',
          field: 'ding_dan_lei_xing'
        },
        {
          title: '销售日期',
          field: 'bill_date'
        },
        {
          title: '业务员',
          field: 'saler_name'
        },
        {
          title: '客户',
          field: 'company_id'
        },
        {
          title: '交货日期',
          field: 'jiao_huo_ri_qi',
          slots: { default: 'default_jiao_huo_ri_qi' }
        },
        {
          title: `${this.diffSearchTypeShowData.type}图片`,
          field: 'list_chan_pin_tu',
          slots: { default: 'default_list_chan_pin_tu' },
          width: 63
        },
        {
          title: `${this.diffSearchTypeShowData.type}名称`,
          field: 'name',
          width: 120
        },
        {
          title: '规格(mm)',
          field: 'spec',
          width: 120
        },
        {
          title: '单位',
          field: 'unit',
          width: 60
        },
        {
          title: '数量',
          field: 'counts'
        },
        {
          title: '单价(元)',
          field: 'goods_price'
        },
        {
          title: '金额(元)',
          field: 'goods_amount'
        }
      ]
      let resultOrderYes = [
        {
          title: '订单单价(元)',
          field: 'sales_price',
          width: 100
        },
        {
          title: '订单金额(元)',
          field: 'sales_amount',
          width: 100
        },
        {
          title: '修改人',
          field: 'last_update_name',
          width: 100
        },
        {
          title: '最近一次修改时间',
          field: 'last_update_date',
          width: 140
        }
      ]
      let resultOrderNo = [
        {
          title: '工程图',
          field: 'list_gong_cheng_tu',
          slots: { default: 'default_list_gong_cheng_tu' },
          width: 63
        },
        {
          title: '源文件',
          field: 'list_yuan_wen_jian',
          slots: { default: 'default_list_yuan_wen_jian' }
        },
        {
          title: '检测模板',
          field: 'list_jian_ce_mu_ban',
          slots: { default: 'default_list_jian_ce_mu_ban' }
        },
        {
          title: '检测报告',
          field: 'list_jian_ce_bao_gao',
          slots: { default: 'default_list_jian_ce_bao_gao' }
        },
        {
          title: '进度',
          field: 'jin_du',
          slots: { default: 'default_jin_du' },
          width: 132
        }
      ]
      let isLastChooseOrder =
        this.left_filter_data.search_type === '单据' && !this.isLeftLastChooseGoods
      let resultCenter = isLastChooseOrder ? resultOrderYes : resultOrderNo
      let resultEnd = [
        {
          title: '备注',
          field: 'remark',
          width: 120
        },
        {
          title: '单据备注',
          field: 'bill_remark',
          width: 120
        },
        {
          fixed: 'right',
          title: '操作',
          field: 'operate',
          slots: { default: 'default_operate' },
          width: 73
        }
      ]
      let result = [...resultStart, ...resultCenter, ...resultEnd]
      this.$util.initTableColumnWidth(this.$options.tableName, result, 'inherit')
      return result
    }
  },
  watch: {
    bill_status1() {
      this.searchListData()
    }
  },
  mounted() {
    this.isLoadTab = false
    if (this.$route.query.status) {
      this.bill_status1 = this.$route.query.status
    }
    this.isLoadTab = true
  },
  methods: {
    // 列宽变化，保存单列宽度
    handleColumnResize({ column }) {
      this.$util.setTableColumnWidth(this.$options.tableName, column.field, column.resizeWidth)
    },
    // 更新页面
    updatePage() {
      this.$refs.refLeftFilter.updateFilterGroupData()
      this.searchListData()
    },
    // 重置左侧筛选
    resetLeftFilter() {
      if (!this.left_filter_data.list.length) {
        let result = {
          search_type: this.init_filter_data.active_search_type,
          list: []
        }
        this.updateLeftFilter(result)
      }
    },
    // 更新左侧筛选
    updateLeftFilter(val) {
      this.left_filter_data = this.$util.deepCopy(val)
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.loading = true
      let params = {
        currentPage: this.pageOptions.currentPage,
        pageSize: this.pageOptions.pageSize,
        bill_status1: this.search_data.bill_status1,
        bill_date: this.search_data.bill_date,
        sortData: this.$util.deepCopy(this.sortData)
      }
      if (this.left_filter_data.list.length) params.left_filter = this.left_filter_data.list

      let url = ''
      if (this.left_filter_data.search_type === '单据') url = '/admin/gcvip/pmc/list3ShangPin'
      if (this.left_filter_data.search_type === '原料') url = '/admin/gcvip/pmc/list3YuanLiao'
      if (this.left_filter_data.search_type === '加工') url = '/admin/gcvip/pmc/list3JiaGong'
      if (this.left_filter_data.search_type === '费用') url = '/admin/gcvip/pmc/list3QiTaFeiYong'

      this.$api({
        method: 'post',
        url,
        data: params
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            let list = this.$util.deepCopy(data.list)
            this.tableData = list

            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber

            this.totalObj.dai_zhi_xing_count = res.data.dai_zhi_xing_count
            this.totalObj.zhi_xing_zhong_count = res.data.zhi_xing_zhong_count
            this.totalObj.yi_wan_cheng_count = res.data.yi_wan_cheng_count
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 获取-当前单选行
    getCheckboxRecords() {
      return this.$refs.refTable.getCheckboxRecords()
    },
    // 表格-高亮行更改
    tableCurrentChange(params) {
      this.$refs.refTable.setCheckboxRow(params.row, true) // 选中checkbox
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowCheckbox = this.$refs.refTable.isCheckedByCheckboxRow(row)
        this.$refs.refTable.setCheckboxRow(row, !isCurrentRowCheckbox) // 选中checkbox
      }
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 表格底部
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          let counts = this.$tool.listAddTotal(data, 'counts')
          let goods_amount = this.$tool.listAddTotal(data, 'goods_amount')
          let sales_amount = this.$tool.listAddTotal(data, 'sales_amount')
          if (columnIndex === 0) return '合计'
          if (column.field === 'counts') return counts
          if (column.field === 'goods_amount') return goods_amount
          if (column.field === 'sales_amount') return sales_amount
        })
      ]
    },
    // 行类名计算，实现按字段分组的斑马纹效果
    cellClassName(rowData) {
      let result = this.$tool.getTableCellClassName(this.tableData, rowData, 'a_id')
      return result
    },

    // 项-制造明细
    itemMadeDetail(id) {
      this.activeBillId = id
      this.isShowPopupVerifyGoodsDetail = true
    },
    // 项-制造流程
    itemMadeView(id) {
      this.activeBillId = id
      this.isShowPopupVerifyGoodsView = true
    },
    // 设置执行中
    itemSetDoing(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/pmc/zhiXing',
        params: {
          id
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success(res.data.msg)
            this.getListData()
          }
        })
        .catch(() => {})
    },
    // 设置已完成
    itemSetComplete(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/pmc/wanCheng',
        params: {
          id
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success(res.data.msg)
            this.getListData()
          }
        })
        .catch(() => {})
    },
    // 项-销售订单
    itemXiaoShou(id) {
      this.activeBillId = id
      this.isShowPopupXiaoShou = true
    },
    // 项-生产工单
    itemRenwu(billId, jiagongId) {
      this.activeBillId = billId
      this.activeJiagongId = jiagongId
      this.isShowPopupRenwu = true
    },
    // 项-委外工单
    itemWeiwai(billId, jiagongId) {
      this.activeBillId = billId
      this.activeJiagongId = jiagongId
      this.isShowPopupWeiwai = true
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm(`销售单号：${row.bill_code}，是否删除该订单?`, '提示')
        .then(() => {
          this.itemDeleteConfirm(row.a_id)
        })
        .catch(() => {})
    },
    // 项-删除-确认
    itemDeleteConfirm(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/pmc/delete',
        params: {
          id
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success(res.data.msg)
            this.getListData()
          }
        })
        .catch(() => {})
    },

    // 批量操作
    // 生成采购申请单
    batchPurchaseApply() {
      let rows = this.getCheckboxRecords()
      if (rows.length) {
        this.isShowPopupBatchPurchaseApply = true
        this.activeBatchList = this.$util.deepCopy(rows)
      } else {
        this.itemChoosePrompt()
      }
    },

    // 批量完成（取“待执行”前20张单据，逐条调 wanCheng 置为已完成）
    async itemFinishBatch() {
      this.finishLoading = true
      let successCount = 0
      let failCount = 0
      try {
        // 1. 拉待执行列表（商品维度，需按 a_id 去重），取前20张单据
        let listRes = await this.$api({
          method: 'post',
          url: '/admin/gcvip/pmc/list3ShangPin',
          data: {
            currentPage: 1,
            pageSize: 200,
            bill_status1: '待执行',
            bill_date: [],
            sortData: { a_id: 'desc' }
          }
        })
        if (listRes.data.state !== 'ok') return
        let list = listRes.data.page.list || []
        if (!list.length) {
          this.$message.warning('没有待执行的PMC订单')
          return
        }
        // 按 a_id 去重，取前20个
        let aIdList = []
        list.forEach((item) => {
          if (!aIdList.includes(item.a_id)) aIdList.push(item.a_id)
        })
        aIdList = aIdList.slice(0, 20)

        // 2. 逐条串行：调 wanCheng 置为已完成
        for (let i = 0; i < aIdList.length; i++) {
          let aId = aIdList[i]
          try {
            let res = await this.$api({
              method: 'get',
              url: '/admin/gcvip/pmc/wanCheng',
              params: { id: aId }
            })
            if (res.data.state === 'ok') {
              successCount++
            } else {
              failCount++
            }
          } catch (e) {
            failCount++
          }
        }
        this.$message.success(`批量完成完毕：成功${successCount}条，失败${failCount}条`)
        this.updatePage()
      } catch (e) {
        // 拦截器已统一提示错误
      } finally {
        this.finishLoading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
